import { utils } from '../../../utils/utils';

export function getStyles(styleParams) {
  let wixSdk = Wix;
  try {
    if (utils.isInSettings()) {
      wixSdk = window.parent.Wix;
    }
  } catch (error) {

  }
  return new Promise(resolve => resolve())
    .then(() => {
      const getColor = (name, _default) => styleParams[name] ? styleParams[name].value : _default
      const getFont = (name, _default) => styleParams[name] || wixSdk.Styles.getStyleFontByReference(_default)

      const color1 = utils.hexToRgba(wixSdk.Styles.getColorByreference('color-1').value, 1)
      const color5 = utils.hexToRgba(wixSdk.Styles.getColorByreference('color-5').value, 1)
      const paragraph2 = wixSdk.Styles.getStyleFontByReference('Body-M')

      const background = getColor('bgColorExpand', color1)
      const titleColor = getColor('titleColorExpand', color5)
      const descriptionColor = getColor('descriptionColorExpand', color5)
      const buttonColor = getColor('addToCartColorExpand', color1)
      const buttonBackground = getColor('addToCartBackColorExpand', color5)

      const titleFont = getFont('titleFontExpand', 'Heading-M')
      const descriptionFont = getFont('descriptionFontExpand', 'Body-M')
      const buttonFont = getFont('style.addToCartFontExpand', 'Body-M')

      const styles = {
        title: {
          font: titleFont,
          color: titleColor,
        },
        description: {
          font: descriptionFont,
          color: descriptionColor,
        },
        button: {
          font: buttonFont,
          color: buttonColor,
          background: buttonBackground,
        },
        background: {
          color: background
        },
      }

      return {
        hrefs: getFontsHrefs(titleFont, descriptionFont, paragraph2, buttonFont),
        styles,
      }
    })
}

function getFontsHrefs(...fonts) {
  const googleHrefs = fonts
    .map(font => (font.fontFamily))
    .map(fontFamily => getGoogleFontHref(fontFamily))
    .filter(font => font)
  return getWixFontsHrefs()
    .concat(googleHrefs)
}

function getWixFontsHrefs() {
  const removeHttp = href => href.replace('http:', '')
  const removeHttps = href => href.replace('https:', '')
  return [...document.styleSheets]
    .map(({ href }) => href)
    .filter(href => href && href.toLowerCase().indexOf('font') >= 0)
    .map(href => removeHttps(href))
    .map(href => removeHttp(href))
    .map(href => 'https:' + href)
}

function getGoogleFontHref(fontFamily) {
  const font = getGoogleFonts()
    .find((font) => font.fontFamily === fontFamily)
  return font ? 'https://fonts.googleapis.com/icon?family=' + font.cdnName : null
}

function getGoogleFonts() {
  const editorFonts = Wix.Styles.getEditorFonts() || []
  const wixFontsArrays = editorFonts.map(obj => obj.fonts)
  const fonts = [].concat(...wixFontsArrays)
  const googleFonts = fonts.filter(font => font.provider === 'google')
  return googleFonts;
}



// WEBPACK FOOTER //
// ./store/applications/components/ProviderStyles.js